export enum TypeLikeFeedNews {
	THUMBUP = "thump-up",
	HEART = "heart",
	CLAP = "clap",
	THINKING = "thinking",
	IDEA = "idea"
}
